module.exports = __webpack_public_path__ + "static/media/3DPPA34.f92993ad.jpg";